import React, { useCallback, useEffect } from 'react';
import Img from 'react-cool-img';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-v5';
import { sendRecoveryEmail } from 'spw-redux/modules/auth/actions';
import HourglassBottom from 'spw-static/images/hourglass-bottom.svg';
import Close from 'spw-static/images/delete-input-icon.svg';
import { UnstyledReactLink } from 'spw-shared/globalComponents';
import {
  DialogBox,
  DialogCustom,
  GradientBackgroundContainer,
  CloseButton,
  ButtonCustom,
} from '../styles';

const ExpiredPasswordResetLink = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { oldToken } = useParams<{ oldToken: string }>();

  useEffect(() => {
    localStorage.removeItem('api_token_v2');
    localStorage.removeItem('user_token');
  }, []);

  const handleButtonClick = useCallback(() => {
    if (oldToken) {
      dispatch(sendRecoveryEmail({ token: oldToken }));
    } else {
      history.push('/auth/password-reset');
    }
  }, [dispatch, oldToken, history]);

  return (
    <GradientBackgroundContainer>
      <DialogBox success>
        <DialogCustom>
          <Img
            src={HourglassBottom}
            alt="recovery email sent"
            className="icon-image"
          />
          <UnstyledReactLink to="/login">
            <CloseButton>
              <Img src={Close} alt="close" />
            </CloseButton>
          </UnstyledReactLink>
          <div className="title">PASSWORD LINK EXPIRED!</div>
          <ButtonCustom variant="contained" onClick={handleButtonClick}>
            Resend Recovery Link
          </ButtonCustom>
        </DialogCustom>
      </DialogBox>
    </GradientBackgroundContainer>
  );
};

export default ExpiredPasswordResetLink;
